import axios from 'axios';
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import Card from '../components/Card';
import Footer from '../components/Footer';
import ListWisata from '../components/List/ListWisata';
import Navbar from '../components/Navbar';

export default function Explore() {
  const [explore, setExplore] = useState('');

  useEffect(() => {
    axios.get('http://localhost:3004/explore').then((res) => {
      setExplore(res.data);
      console.log(res.data);
    });
  }, []);
  return (
    <div>
      <div className="relative bg-cover after:bg-opacity-50 after:bg-gradient-to-b after:from-black after:content-[''] after:w-full after:h-full after:absolute after:bottom-0">
        <div className="container mx-auto px-[4%]">
          <Navbar />
        </div>
        <div className="flex flex-col justify-center items-center">
          <img
            src="/assets/images/image-explore.png"
            alt="image-explore"
            className="md:-mt-[150px] md:h-auto mt-0 h-[464px]"
          />
          <h1 className="text-[36px] text-white -mt-[5%] font-medium z-10 w-2/5 text-center absolute">
            Explore Berbagai Tempat Keren di Daerah Tegal
          </h1>
        </div>
      </div>
      <Card
        textLeft="Kafe & Bistro"
        textCenter="Penginapan"
        textRight="Galeri UMKM"
        amountLeft={explore.length}
        amountCenter={explore.length}
        amountRight={explore.length}
      />

      <div className="container mx-auto p-[4%] grid grid-cols-2 gap-6 items-center font-[Rubik]">
        <div>
          <p className="text-2xl text-black font-medium mb-8">Event Populer</p>
          <img src="/assets/images/kafe.png" alt="kafe" className="h-[460px]" />
        </div>
        <div>
          <p className="text-4xl text-black font-medium">Arthome Cafe</p>
          <div className="flex items-center">
            <img src="/assets/images/location.svg" alt="location" />
            <p className="md:text-lg text-sm text-[#666666] mx-4">Citraland, Tegal</p>
            <button className="bg-button border border-button rounded-[100px] px-5 py-2 md:text-base text-xs text-primary">
              Lihat di Map
            </button>
          </div>
          <p className="text-base text-[#999999] mb-6">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed tortor aliquam, congue
            mauris neque, interdum magna diam. Eu magna metus, mauris, ut nunc tellus suspendisse
            risus. Dictum id nisl, nulla malesuada feugiat hendrerit nullam erat pulvinar. Egestas
            mauris eget feugiat commodo sed eget non eget gravida.
          </p>
          <button className="bg-primary text-white tex-base px-7 py-3 rounded">
            Explore Sekarang
          </button>
        </div>
      </div>

      <div className="container mx-auto p-[4%]">
        <ListWisata data={explore} object="Kafe & Bistro" />
        <ListWisata data={explore} object="Penginapan" />
        <ListWisata data={explore} object="Galeri UMKM" />
      </div>
      <Footer />
    </div>
  );
}
